var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"targets"},[_vm._l((_vm.targets),function(target){return _c('target-card',{key:target.id,staticClass:"float-left",attrs:{"target":target},on:{"target-deleted":_vm.updateTargets}})}),_c('target-card',{on:{"target-saved":_vm.updateTargets}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }